(() => {
  'use strict';

  const endpoint = String(window.FGNewsletterConfig?.endpoint || '').trim();
  if (!endpoint) return;

  const forms = [
    {
      element: document.querySelector('#FooterNewsletter'),
      source: 'footer',
      success: 'Thank you. Check your inbox to confirm.'
    },
    {
      element: document.querySelector('#NewsletterPopupForm'),
      source: 'newsletter-popup',
      success: document.querySelector('#NewsletterPopupForm')?.dataset.newsletterSuccess || 'Thank you. Check your inbox for the next step.'
    }
  ];

  const showResponse = (form, message, isError) => {
    let response = form.querySelector('[data-newsletter-api-response]');
    if (!response) {
      response = document.createElement('p');
      response.dataset.newsletterApiResponse = '';
      const anchor = form.querySelector('.newsletter-popup-field, .footer-signup');
      if (anchor) anchor.before(response);
      else form.append(response);
    }
    response.className = `newsletter-api-response${isError ? ' newsletter-api-response--error' : ''}`;
    response.setAttribute('role', isError ? 'alert' : 'status');
    response.textContent = message;
  };

  forms.forEach(({ element: form, source, success }) => {
    if (!form) return;

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.newsletterSubmitting === 'true') return;

      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const honeypot = form.querySelector('[data-newsletter-honeypot]');
      if (!emailInput || !emailInput.reportValidity()) return;

      form.dataset.newsletterSubmitting = 'true';
      form.setAttribute('aria-busy', 'true');
      if (submitButton) submitButton.disabled = true;

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);

      try {
        const apiResponse = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: emailInput.value,
            source,
            page: window.location.href,
            company: honeypot?.value || ''
          }),
          signal: controller.signal
        });
        const result = await apiResponse.json().catch(() => ({}));
        if (!apiResponse.ok || !result.ok) throw new Error(result.message || 'Signup failed. Please try again.');

        showResponse(form, success, false);
        emailInput.value = '';
        const field = form.querySelector('.newsletter-popup-field, .footer-signup');
        if (field) field.hidden = true;
        const note = form.querySelector('.newsletter-popup-note');
        if (note) note.hidden = true;
      } catch (error) {
        const message = error?.name === 'AbortError'
          ? 'Signup is taking too long. Please try again.'
          : (error?.message || 'Signup failed. Please try again.');
        showResponse(form, message, true);
      } finally {
        window.clearTimeout(timeout);
        form.dataset.newsletterSubmitting = 'false';
        form.removeAttribute('aria-busy');
        if (submitButton) submitButton.disabled = false;
      }
    });
  });
})();
